import React, { useState, useEffect, FormEvent, ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Upload, Icon } from "antd";
import { Modal } from "../../helpers/commonUi";
import style from "./orgs.module.sass";
import { Http } from "../../helpers/axois";
import { IOrgListCards } from "./org";
import { setCurrentOrganization } from '../../stateManager/store/orgs/actions'
import { useToast } from '../../helpers/commonFunction'
import { logger } from "../../constant/winston";

const { TextArea } = Input;

interface ICreateOrgs {
  visible: boolean;
  visibleChange: (data: boolean) => void;
  editable?: boolean;
  orgdata?: IOrgListCards;
  loadAPIcards?: () => void;
  setRowKey?: (data: any) => void;
  setParentModalVisibility?: (data: boolean) => void
}
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

function getBase64(img: any, callback: any) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

// const initialdata = {
//   name: "",
//   primaryEmail: "",
//   description: "",
//   img: ""
// };

const initialValidationState = {
  name: "",
  displayName: '',
  primaryEmail: "",
  description: "",
  img: ""
};
const Initialstate = {
  img: "",
  loading: false,
  previewVisible: false,
  editimg: true
};
const CreateOrgs = ({
  visible,
  visibleChange,
  editable,
  orgdata,
  loadAPIcards,
  setParentModalVisibility,
  setRowKey,
  ...props
}: ICreateOrgs) => {
  const [state, setmodaldata]: any = useState(Initialstate);
  const [errorState, setErrorState]: any = useState(initialValidationState);
  const [formstate, setformstate] = useState<any>({});
  const [createloading, setcreateloading]: any = useState(false);
  // const [formstate, setformstate]: any = useState(
  //   orgdata ? orgdata : { ...initialdata }
  // );
  const { ErrorToast } = useToast()
  const dispatch = useDispatch()
  const currentOrg = useSelector((selectorState: any) => {
    return selectorState && selectorState.org && selectorState.org.selectedOrg
  })

  useEffect(() => {
    if (editable) {
      setformstate(orgdata)
      setmodaldata({
        ...formstate,
        loading: true
      });
      Http.get("/orgs/image/profilePhoto/" + orgdata!.id).subscribe(
        (res: any) => {
          setformstate({
            ...formstate,
            img:
              res.photo !== "undefined"
                ? "data:image/*;base64," + res.photo
                : ""
          });
          setmodaldata({
            ...formstate,
            loading: false
            // img: dataURLtoFile("data:image/*;base64," + res.photo, "image.txt")
          });
        },
        (err) => {
          setmodaldata({
            ...formstate,
            loading: false
          });
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgdata]);

  const formsetState = (key: string) => (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const changedValue = e.target.value
    let inputLabel = "";
    if (key === "displayName") {
      let val =  changedValue.replace(/[^a-zA-Z0-9_\s]/g, "") 
      let value =  val.replace(/ /g,"_")
      setformstate((prevState: any) => ({ ...prevState, displayName: val, orgName: value})) 
      inputLabel = "Display Name"
    }
    else if (key === "orgName") {
      let val = 
      setformstate((prevState: any) => ({
        ...prevState,
        orgName: changedValue.replace(/[^a-zA-Z0-9_\s]/g, "").replace(/ /g, "_")
      }));
      inputLabel = "Name"
    }
    else if (key === "description") {
      setformstate((prevState: any) => ({
        ...prevState,
        description: changedValue
      }));
      inputLabel = "Description"
      if (changedValue.length > 500) {
        checkvalidation(key, 'Description must have less than 500 characters')
      }
    }

    changedValue === ""
      ? checkvalidation(key, `${inputLabel} required`)
      : checkvalidation(key, ``);
  };

  const checkvalidation = (name: string, errmsg: string) => {
    setErrorState({
      ...errorState,
      [name]: errmsg
    });
  };

  function beforeUpload(file: any) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setmodaldata({
        ...formstate,
        loading: false
      });
      checkvalidation("img", "You can only upload JPG/PNG file!");
      setTimeout(() => {
        checkvalidation("img", "");
      }, 2000);
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      setmodaldata({
        ...formstate,
        loading: false
      });
      checkvalidation("img", "Image must smaller than 2MB!");
      setTimeout(() => {
        checkvalidation("img", "");
      }, 2000);
    }
    return isJpgOrPng && isLt2M;
  }
  const handleChange = (info: any) => {
    if (info.file.status === "uploading") {
      setmodaldata({
        ...formstate,
        loading: true
      });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl: any) => {
        setmodaldata({ loading: false, img: info.file.originFileObj });
        setformstate({ ...formstate, img: imageUrl });
        checkvalidation("img", "");
      });
    } else if (info.file.status === "error") {
      setmodaldata({ loading: false, img: info.file.originFileObj });
      checkvalidation("img", "file upload failed.");
      setTimeout(() => {
        checkvalidation("img", "");
      }, 1000);
    }
  };

  const handleOK = () => {
    setcreateloading(false);
    if (formstate.orgName && formstate.description && formstate.orgName !== "" && formstate.description !== "") {
      if (errorState.description === "" && errorState.name === "" && errorState.displayName === "" && errorState.img === "") {
        setmodaldata({
          ...formstate,
          loading: true
        });
        const formData = new FormData();
        state.img && formData.append("profilePhoto", state.img);
        formData.append("orgName", formstate.orgName);
        formData.append("description", formstate.description);
        formData.append("displayName", formstate.displayName ? formstate.displayName : formstate.orgName);
        if (!editable) {
          Http.post("/org/create", formData).subscribe(
            (res: any) => {
              visibleChange(false);
              setmodaldata({
                ...formstate,
                loading: false
              });
              setformstate({
                orgName: '',
                description: ''
              })
              dispatch(setCurrentOrganization({ selectedOrg: { id: res[0].org_id, orgName: formstate.orgName, owner: res[0].created_by } }))
              setRowKey && setRowKey(res[0].org_id);
              loadAPIcards && loadAPIcards();
            },
            err => {
              logger.error("error in org create", err);
              ErrorToast(err.message);
              visibleChange(false);
              console.log(orgdata, formstate, "org data and formstage")
              setformstate({
                orgName: '',
                description: ''
              })
              setmodaldata({
                ...formstate,
                loading: false
              });
            }
          );
        } else {
          Http.put("/orgs/" + orgdata!.id, formData).subscribe(
            (res: any) => {
              visibleChange(false);
              setmodaldata({
                ...formstate,
                loading: false
              });
              setformstate({
                orgName: '',
                description: ''
              });
              if (currentOrg.orgName === orgdata!.orgName) {
                dispatch(setCurrentOrganization({ selectedOrg: { id: orgdata && orgdata.id, orgName: formstate.orgName, owner: orgdata && orgdata.created_by } }))
              }
              loadAPIcards && loadAPIcards();
              setParentModalVisibility && setParentModalVisibility(true);
            },
            err => {
              logger.error("err");
              ErrorToast(err.message);
              setmodaldata({
                ...formstate,
                loading: false
              });
            }
          );
        }
      }
    } else {
      ErrorToast('Please fill the mandatory fields')
      // setValstate({
      //   ...valstate,
      //   displayName: `display Name required`,
      //   orgName: `orgName required`,
      //   description: "description required"
      // });
    }
  };

  const uploadButton = (
    <div>
      <Icon type={state.loading ? "loading" : "plus"} />
      <div className="ant-upload-text">Upload</div>
    </div>
  );
  const handleCancel = () => setmodaldata({ ...state, previewVisible: false });

  return (
    <Modal
      id="createEditOrg"
      dataTestId="create_edit_org"
      // mode='EditCreate'
      unmountOnCancel={true}
      title={editable ? 'EDIT ORGANIZATION' : 'CREATE ORGANIZATION'}
      visible={visible}
      loading={createloading}
      onCancel={() => {
        setformstate({
          ...formstate,
          displayName: "",
          orgName: "",
          description : "",
          img: ""
        });
        setErrorState({
          ...errorState,
          displayName: "",
          orgName: "",
          description: ""
        });
        visibleChange(false);
        setParentModalVisibility && setParentModalVisibility(true);
      }}
      footer={{
        enable: true,
        okText: editable ? "SAVE" : "CREATE",
        cancelText: 'CANCEL',
        onOk: handleOK
      }}
    >
      <Form data-test-id="create_orgs" {...formItemLayout} className={style.app + ' override-content'}>
        <Form.Item
          hasFeedback={false}
          required
          validateStatus={errorState.displayName ? "error" : ""}
          help={errorState.displayName}
          label={<span className={style.labelName}>Display Name</span>}
        >
          <Input
            data-test-id="display_name"
            value={(formstate.displayName) ? formstate.displayName : formstate.orgName}
            onChange={(e) => formsetState("displayName")(e)}
            maxLength={100}
          />
        </Form.Item>
        {!editable && <Form.Item
          hasFeedback={false}
          required
          validateStatus={errorState.orgName ? "error" : ""}
          help={errorState.orgName}
          label="Name (identifier)"
        >
          <Input
            data-test-id="name"
            value={formstate.orgName}
            onChange={(e) => formsetState("orgName")(e)}
            maxLength={100}
          />
        </Form.Item>}
        <Form.Item
          required
          validateStatus={errorState.description ? "error" : ""}
          // help={valstate.name}
          //   validateStatus={valstate.description && "error"}
          help={errorState.description}
          label="Description"
        >
          <TextArea
            data-test-id="text_area"
            value={formstate.description}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => formsetState("description")(e)}
            rows={4}
            maxLength={500}
          />
        </Form.Item>

        <Form.Item
          validateStatus={errorState.img && "error"}
          help={<div style={{ marginTop: "-22px" }}>{errorState.img}</div>}
          label="Avatar"
        >
          <Upload
            data-test-id="upload"
            openFileDialogOnClick={state.editimg}
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            beforeUpload={beforeUpload}
            onChange={handleChange}
          >
            {formstate.img ? (
              <React.Fragment>
                <img
                  data-test-id="avatar"
                  src={formstate.img}
                  // onClick={handlePreview}
                  alt="avatar"
                  style={{ width: "100%" }}
                />
                {state.loading && formstate.img && (
                  <React.Fragment>
                    <Icon data-test-id="loading_plus" type={state.loading ? "loading" : "plus"} />
                  </React.Fragment>
                )}{" "}
              </React.Fragment>
            ) : (
              uploadButton
            )}

            <Modal
              id="previewOrg"
              dataTestId="preview_org"
              visible={state.previewVisible}
              unmountOnCancel={true}
              // mode='EditCreate'
              footer={{
                enable: false
              }}
              onCancel={handleCancel}
            >
              <img
                alt="example"
                style={{ width: "100%" }}
                src={formstate.img}
              />
            </Modal>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateOrgs;
